import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Alert from 'fe-design-base/molecules/Alert';
import Link from 'fe-design-base/molecules/Link/Link';

import { toI18n } from 'util/i18n';

import { TOO_MANY_REQUESTS_ERROR_MESSAGE } from '../constants';

import ContactUsButton from './ContactUsButton';

type Props = {
  title: string;
  dataTestId: string;
  children: React.ReactNode;
  description?: string;
  descriptionI18nProps?: Record<string, any>;
  backLinkTo?: string;
  onBackClick?: () => void;
  alertError?: string;
};

const HeaderLayout = ({
  title,
  description,
  descriptionI18nProps,
  backLinkTo,
  onBackClick,
  alertError,
  dataTestId,
  children,
}: Props) => (
  <Box maxw={420} w="100%">
    <Box column gap={16} pb={16}>
      {(backLinkTo || onBackClick) && (
        <Link
          startIcon="ChevronLeft"
          uxElement="back link"
          linkTo={backLinkTo}
          onClick={onBackClick}
        >
          {toI18n('authentication.back_link')}
        </Link>
      )}
      <Text variant="heading1" i18n={title} />

      {alertError && (
        <Alert
          variant="error"
          dataTestId={`${dataTestId}__alert`}
          action={
            alertError === TOO_MANY_REQUESTS_ERROR_MESSAGE ? (
              <ContactUsButton />
            ) : undefined
          }
          forceStacked
        >
          {alertError}
        </Alert>
      )}

      {description && (
        <Text i18n={description} i18nProps={descriptionI18nProps} />
      )}
    </Box>
    {children}
  </Box>
);

export default HeaderLayout;
